<template>
  <!-- Figma missed: same split as incoming — hero copy left, rail = icon + CTAs -->
  <v-container fluid class="pa-0 fill-height bg-backgroundBase vc-incoming-root">
    <PatientBackground />

    <div class="vc-incoming-hero">
      <h1 class="vc-incoming-hero__title text-wrap">A nurse just tried to contact you.</h1>
      <p class="vc-incoming-hero__purpose text-wrap">{{ subtitle }}</p>
    </div>

    <v-sheet
      class="vc-incoming-panel d-flex flex-column bg-white"
      elevation="24"
      height="100%"
      rounded="0"
    >
      <div class="mb-16">
        <v-icon class="vc-rail__video-icon" color="primary">mdi-video-plus-outline</v-icon>
      </div>

      <div class="flex-grow-1" aria-hidden="true" />

      <div class="vc-rail-cta-stack mt-auto pt-2">
        <VBtnPrimary
          block
          class="vc-incoming-action text-none"
          size="x-large"
          @click="handleAvailable"
        >
          I'm Available
          <v-icon end size="large">mdi-check</v-icon>
        </VBtnPrimary>

        <VBtnTextDark
          block
          class="vc-incoming-decline text-none"
          size="x-large"
          @click="handleCallBackLater"
        >
          Call Back Later
          <v-icon end color="dark" size="large">mdi-close</v-icon>
        </VBtnTextDark>
      </div>
    </v-sheet>
  </v-container>
</template>

<script setup lang="ts">
import { computed, onMounted, onBeforeUnmount } from 'vue'
import { useRouter } from 'vue-router'
import { useCallStore } from '../stores/callStore'
import { apiClient } from '../services/apiClient'
import PatientBackground from '../components/PatientBackground.vue'
import { missedCallAvailabilityLine } from '@virtual-care/shared'

interface Props {
  sessionId?: string
}

const props = defineProps<Props>()
const router = useRouter()
const callStore = useCallStore()

const resolvedSessionId = computed(() =>
  callStore.sessionId ?? props.sessionId
)

const subtitle = computed(() => missedCallAvailabilityLine(callStore.callPurpose))

const handleAvailable = async () => {
  console.log('[MissedCallView] handleAvailable clicked, sessionId:', resolvedSessionId.value)
  if (resolvedSessionId.value) {
    try { await apiClient.respondAvailability(resolvedSessionId.value, 'available') } catch { /* best-effort */ }
  }
  router.push('/availability-confirm')
}

const handleCallBackLater = () => {
  console.log('[MissedCallView] handleCallBackLater clicked')
  router.push('/')
}

onMounted(() => {
  console.log('[MissedCallView] Mounted with sessionId:', resolvedSessionId.value, 'status:', callStore.status)
})

onBeforeUnmount(() => {
  console.log('[MissedCallView] Unmounting')
})
</script>
